import { FC, memo } from 'react'

import { Stake } from '@/components/atoms/assets/Stake'
import { Button } from '@/components/atoms/Button'

type StakeButtonProps = {
  text: string
  onClick?: () => void
  className?: string
}

const StakeButtonComponent: FC<StakeButtonProps> = ({
  text,
  onClick,
  className = '',
}) => {
  return (
    <Button className={className} type="primary" onClick={onClick}>
      <Stake className="-ml-1 h-6" />
      <span className="text-xxs xs:text-xs">{text}</span>
    </Button>
  )
}

export const StakeButton = memo(StakeButtonComponent)
